import React, { useEffect, useCallback, useState} from 'react';
import WetSlider from './WetSlider.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import {connect} from 'react-redux';

const RingModulatorComponent = ({effectNumber, effect, sequencerEngine}) => { 
    return (
        <div className="ring-modulator">
          <EffectParameterSlider
            effectNumber={effectNumber}
            name='Frequency'
            sequencerEngine={sequencerEngine}
            lfoEnabled={true}
            parameter={effect.frequencyParameter}
            isParameter={true}
            step={0.01}
            max={3000}
            min={20}
          />
          <EffectParameterSlider
            effectNumber={effectNumber}
            name='Distortion'
            sequencerEngine={sequencerEngine}
            lfoEnabled={false}
            parameter={effect.distortionParameter}
            isParameter={true}
            step={0.01}
            max={3}
            min={0.01}
          />
          <WetSlider
            effectNumber={effectNumber}
            sequencerEngine={sequencerEngine}
            effect={effect}/>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RingModulatorComponent);
